import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'

import lang from '../lang'

export default class extends React.Component {
  state = {}

  constructor(props) {
    super(props)
    let { language } = this.props
  }

  // shouldComponentUpdate(nextProps) {
  //   console.log('shouldComponentUpdate')
  //   // return false
  // }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }
  showBanner =(language)=>{
    console.log(language,'---showTableBg----showTableBg----')
    switch (language) {
      case 'en':
        return (
          <img className="bt" src='/img/app/roomsupport/banne_title_en.png' />
        )
        break;
        case 'ar':
        return (
          <img className="bt" src='/img/app/roomsupport/banne_title_ar.png' />
        )
        break;
        case 'tr':
        return (
          <img className="bt" src='/img/app/roomsupport/banne_title_tr.png' />
        )
        break;
      default:
        return (
          <img className="bt" src='/img/app/roomsupport/banne_title_en.png' />
        )
        break;
    }
    
  }
  render() {
    let { language, lang } = this.props
    return (
      <div className="top">
        <div style={{ height: '7.5rem' }} className='top-img'></div>
        <div className="bd">
          <div className="des">
            {language != 'ar' && <div dangerouslySetInnerHTML={{ __html: lang.ruleDes || '' }} className="tx"></div>}
            {language == 'ar' && <div dangerouslySetInnerHTML={{ __html: lang.ruleDes || '' }} className="tx"></div>}
          </div>
         
        </div>
        {this.showBanner(language)}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/roomsupport/Top/index.js